var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import NumberRange from "~/components/common/number-range.vue";
import { RepairCasesService } from "~/services/domain-service/repair-cases.service";
import RepairInfoUpload from "~/components/common-manages/credit-repair-case/repair-info-upload.vue";
import RepairCaseDistrubute from "~/components/common-manages/credit-repair-case/repair-case-distrubute.vue";
import FixInfo from "~/components/collection-execution/collection-case-info/fix-info.vue";
import CaseAllot from "~/components/distribution-common/case-allot.vue";
import { MENU_CHANNEL } from "~/config/enum.config";
import { namespace } from "vuex-class";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var CollectionExecutionModule = namespace("collection-execution");
var AllotModule = namespace("case-allot");
var CreditRepairCase = /** @class */ (function (_super) {
    __extends(CreditRepairCase, _super);
    function CreditRepairCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fromChanel = MENU_CHANNEL.Letter_repair_case;
        _this.searchModel = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overduePeriod: "",
            overdueDays: {
                min: "",
                max: ""
            },
            caseMoney: { min: "", max: "" },
            labelName: []
        };
        _this.robberyCaseTrue = false;
        _this.repairObj = {};
        _this.dialog = {
            repair: false,
            distrubute: false,
            viewRecord: false
        };
        _this.dataSet = [];
        _this.selectionList = [];
        return _this;
    }
    CreditRepairCase.prototype.refreshData = function () {
        var _this = this;
        this.repairCasesService
            .repairCasesQuery(this.searchModel, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    CreditRepairCase.prototype.activated = function () {
        this.refreshData();
    };
    CreditRepairCase.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * 范围框输入重置
     */
    CreditRepairCase.prototype.handleResetForm = function () {
        this.searchModel.overdueDays = { min: "", max: "" };
    };
    /**
     * 分案
     */
    CreditRepairCase.prototype.manualDistruibute = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要分配的案件");
            return;
        }
        this.updateCaseIds(this.selectionList.map(function (v) { return v.id; }));
        this.dialog.distrubute = true;
    };
    /**
     * 批量下载修复案件
     */
    CreditRepairCase.prototype.downRepairCaseInfos = function () {
        var _this = this;
        var params = __assign({}, this.searchModel);
        if (this.selectionList.length !== 0) {
            params.caseIds = this.selectionList.map(function (v) { return v.id; }).join(",");
        }
        this.repairCasesService
            .downRepairCaseInfos(params)
            .subscribe(function (data) { return _this.$common.downloadFile(data.url); });
    };
    /**
     * 进入查看执行页
     */
    CreditRepairCase.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Letter_repair_case,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    __decorate([
        Dependencies(PageService)
    ], CreditRepairCase.prototype, "pageService", void 0);
    __decorate([
        Dependencies(RepairCasesService)
    ], CreditRepairCase.prototype, "repairCasesService", void 0);
    __decorate([
        AllotModule.Mutation
    ], CreditRepairCase.prototype, "updateCaseIds", void 0);
    __decorate([
        CollectionExecutionModule.Action
    ], CreditRepairCase.prototype, "openCollectionExecution", void 0);
    CreditRepairCase = __decorate([
        Auth(1802),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                RepairInfoUpload: RepairInfoUpload,
                RepairCaseDistrubute: RepairCaseDistrubute,
                CaseAllot: CaseAllot,
                FixInfo: FixInfo
            }
        })
    ], CreditRepairCase);
    return CreditRepairCase;
}(Vue));
export default CreditRepairCase;
